import { data, Outlet } from "react-router";
import { clientCallAPI } from "~/services/clientCallAPI";
export async function loader() {
  try {
    const [listProvince, listArea, listCategory, listPrice] = await Promise.all(
      [
        clientCallAPI("/api/address/province"),
        clientCallAPI("/api/filter/area"),
        clientCallAPI("/api/category"),
        clientCallAPI("/api/filter/price"),
      ]
    );

    return data({
      listProvince: listProvince.data,
      listCategory: listCategory.data,
      listArea,
      listPrice,
    });
  } catch (error) {
    return data({
      listProvince: [],
      listCategory: [],
      listArea: [],
      listPrice: [],
    });
  }
}
function Layout() {
  return <Outlet />;
}

export default Layout;
